// @flow

import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import RoomCardSliderItem from 'components/molecules/room/RoomCardSliderItem'
import MainTemplate from 'components/templates/MainTemplate'
import ReputationListHeader from 'components/organisms/ReputationListHeader'
import HostSummary from 'components/shared/HostSummary'
import ReputationListItem from 'components/molecules/ReputationListItem'
import Breadcrumbs from 'components/shared/Breadcrumbs'
import SpacePageSubTitle from 'components/space/PageSubTitle'
import SpaceRoomList from 'components/space/RoomList'
import SpaceRoomListItem from 'components/space/RoomListItem'
import SpaceSidePlace from 'components/space/SidePlace'
import Review from 'components/space/Review'
import type { Space } from 'types/space'
import { setUIState } from 'redux/modules/ui'
import Path from 'routes/path'

import graphql from './graphql'

type PropTypes = {
  actions: {
    setUIState: setUIState,
  },
  data: {
    space: Space,
    refetch: Function,
  },
  ui: {
    selectedSortType: string,
  },
  actions: {
    setUIState: Function,
    setUser: Function,
  },
  match: {
    params: {
      spaceUsername: ?string,
    },
  },
  config: {
    SPM_GOOGLE_API_KEY: string,
    SERVICE: string,
    ORIGIN: string,
  },
  loadRooms: Function,
  staticContext: Object,
  promotions: Object,
  location: {
    pathname: string,
  },
}

class SpacePage extends Component<PropTypes> {
  render() {
    const { location, config } = this.props
    const { space } = this.props.data
    // 会場が見つからない時または会場に紐づくルームが0件の時は404
    if (space === null || (space && space.rooms.results.length === 0)) {
      this.props.staticContext.status = 404
      return null
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.space.title', { space })}
        description={i18n.t('server.www.space.description', { space })}
        linkCanonical={`${config.ORIGIN}${location.pathname}`}
        {...this.props}
      >
        <Breadcrumbs breadcrumbs={space.breadcrumbs} />
        <div className="site-main">
          <div className="page__odd page__padding">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-8">
                  <h1 className="space-facility_title">
                    {space.name}
                    <span className="space-facility_sub-title">
                      {space.spaceTypeText}
                    </span>
                  </h1>
                  <h2 className="page-subtitle fl">
                    {i18n.t('page.space.roomList')}
                  </h2>
                  <div className="space-main__section-big space-main__otherspace">
                    <SpaceRoomList>
                      <ul className="row">
                        {space.rooms.results.map((room, index: number) => (
                          <SpaceRoomListItem
                            className="col-xs-12 col-md-6"
                            key={`SpaceRoomListItem${index}`}
                          >
                            <RoomCardSliderItem
                              room={{
                                ...room,
                                reputationScore: room.reputationSummary.score,
                                reputationsCount: room.reputationSummary.count,
                              }}
                              cantFavorite
                            />
                          </SpaceRoomListItem>
                        ))}
                      </ul>
                    </SpaceRoomList>
                  </div>
                </div>
                <SpaceSidePlace
                  {...space}
                  googleMapReactBootstrapURLKeys={{
                    key: this.props.config.SPM_GOOGLE_API_KEY,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="page__even page__padding">
            <div className="container">
              <Review>
                <div className="col-sm-12 col-md-8">
                  <SpacePageSubTitle>
                    {i18n.t('page.shared.review.title')}
                  </SpacePageSubTitle>
                  <ReputationListHeader
                    count={space.reputationsCount}
                    score={space.reputationScore}
                  />
                  <div>
                    {space.reputations.results.map(
                      (reputation, index: number) => (
                        <ReputationListItem
                          space={space}
                          reputation={reputation}
                          key={`reputation_list_item_${index}`}
                        />
                      ),
                    )}
                  </div>
                  <div className="mod-more__link">
                    <a
                      href={Path.spaceReputationList(space.username || '')}
                      className="button-blue pt13 pb13 w200"
                    >
                      {i18n.t('page.shared.review.more')}
                    </a>
                  </div>
                </div>
              </Review>
            </div>
          </div>
          {space.owner ? (
            <HostSummary
              owner={space.owner}
              service={this.props.config.SERVICE}
            />
          ) : null}
        </div>
      </MainTemplate>
    )
  }
}

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(SpacePage)),
)



// WEBPACK FOOTER //
// ./src/containers/pages/SpacePage/index.jsx